import React, { useContext } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { UserContext } from '../utils';

export default function IdleModal(props) {
   const userCtx = useContext(UserContext);
   let modalClassName = userCtx.theme ? `${userCtx.theme}` : 'lightTheme';
   return (
      <Modal isOpen={props.isOpen} contentClassName={modalClassName}>
         <ModalHeader
            toggle={props.toggle}
            children="Idle Logout Warning"
         />
         <ModalBody
            children="You will be logged out in 5 minutes due to inactivity. Close this alert to extend your session by 2 hours."
         />
      </Modal>
   )
}